import { render } from "./PageLoading.vue?vue&type=template&id=208bed4e&scoped=true"
const script = {}

import "./PageLoading.vue?vue&type=style&index=0&id=208bed4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208bed4e"]])

export default __exports__